import { render, staticRenderFns } from "./coursesingleview.vue?vue&type=template&id=70662d6e"
import script from "./coursesingleview.vue?vue&type=script&lang=js"
export * from "./coursesingleview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports